"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modificaQuestionarioADV = exports.setisUploadLoading = exports.setADVDatiRedSubmitted = exports.setADVDisabledFirmaAction = exports.setADVDatiDocumentoIdentita = exports.setADVFormDatiReddituali = exports.setADVDatiRedditualiAOriginePatrimonio = exports.setADVDatiRedditualiOrigineReddito = exports.setADVDatiRedditualiAppaltiPubblici = exports.setADVDatiRedditualiUltimaProfessione = exports.setADVDatiRedditualiEsercizioDati = exports.setADVDatiRedditualiTerzoPaese = exports.setADVDatiRedditualiSecondoPaese = exports.setADVDatiRedditualiPrimoPaese = exports.setADVDatiRedditualiNotaTipologia = exports.setADVDatiRedditualiQualificaLavorativa = exports.setADVDatiRedditualiProvinciaAttivitaEconomicaPrevalente = exports.setADVDatiRedditualiStatoAttivitaEconomicaPrevalente = exports.setADVDatiRedditualiPatrimonioTotaleCliente = exports.setADVDatiRedditualiRedditoAnnuo = exports.setADVDatiRedditualiCAE = exports.setADVDatiRedditualiTAE = exports.setADVDatiRedditualiProfessione = exports.setADVScopoRapporto = exports.setADVValorizzaRapporti = exports.setADVFormResidenzaSubmittedAction = exports.setADVDatiResidenzaAction = exports.setADVFormDocumentoSubmittedAction = exports.setADVFilesDocumentoIdentitaAction = exports.setADVDocumentoIdentitaDataScadenzaAction = exports.setADVDocumentoIdentitaDataRilascioAction = exports.setADVDocumentoIdentitaLuogoRilascioAction = exports.setADVDocumentoIdentitaNumeroDocumentoAction = exports.setADVDocumentoIdentitaTipoDocumentoAction = exports.setADVNCivicoDomicilioAction = exports.setADVIndirizzoDomicilioAction = exports.setADVTipoViaDomicilioAction = exports.setADVCAPDomicilioAction = exports.setADVLocalitaDomicilioAction = exports.setADVComuneDomicilioAction = exports.setADVProvinciaDomicilioAction = exports.setADVNCivicoResidenzaAction = exports.setADVIndirizzoResidenzaAction = exports.setADVTipoViaResidenzaAction = exports.setADVCAPResidenzaAction = exports.setADVLocalitaResidenzaAction = exports.setADVComuneResidenzaAction = exports.setADVProvinciaResidenzaAction = exports.getDatiADV = exports.getParametriADV = void 0;
exports.setOrigineDestinazioneFondi = exports.verificaCaricamentoDocumentoADV = exports.setDocumentoModificato = exports.resetTotaleDocumento = exports.resetFormDocumentoIdentita = exports.salvaDocumentoModificato = exports.setADVModificaDocumentoAction = exports.setADVModificaDatiDomicilioAction = exports.getQualificheTaeCaeByProfessione = exports.exportADVPDF = exports.aggiornaDocumentoADV = exports.resetTotaleADV = exports.resetRiepilogoADV = void 0;
const api_rest_1 = require("@sparkasse/api-rest");
const _1 = require(".");
const general_actions_1 = require("../general/general.actions");
const general_configuration_1 = require("../general/general.configuration");
const helpers_1 = require("../helpers");
const adeguataVerifica_types_1 = require("./adeguataVerifica.types");
function generalError(value, showGenericModalError) {
    return async (dispatch) => {
        dispatch((0, general_actions_1.setError)(value, showGenericModalError));
    };
}
//TODO: AGGIUNGERE ULTIMA PROFESSIONE
const getParametriADV = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getParametriADVStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.AdeguataVerificaControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .parametriAdeguataVerifica().then((response) => {
                dispatch(getParametriADVSuccess(response));
                //response.rapporti?.length === 0 && dispatch(setNoRapporti({ type: TypeNoRapporti.ADV }))
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriADV = getParametriADV;
function getParametriADVStart() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_GET_PARAMETRI_START
    };
}
function getParametriADVSuccess(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_GET_PARAMETRI_SUCCESS,
        payload
    };
}
const getDatiADV = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getDatiADVStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.AdeguataVerificaControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .recuperaDati().then((response) => {
                dispatch(getDatiADVSuccess(response));
                //response.rapporti?.length === 0 && dispatch(setNoRapporti({ type: TypeNoRapporti.ADV }))
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getDatiADV = getDatiADV;
function getDatiADVStart() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_GET_DATI_START
    };
}
function getDatiADVSuccess(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_GET_DATI_SUCCESS,
        payload
    };
}
function setADVProvinciaResidenzaAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_RESIDENZA_PROVINCIA,
        payload
    };
}
exports.setADVProvinciaResidenzaAction = setADVProvinciaResidenzaAction;
function setADVComuneResidenzaAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_RESIDENZA_COMUNE,
        payload
    };
}
exports.setADVComuneResidenzaAction = setADVComuneResidenzaAction;
function setADVLocalitaResidenzaAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_RESIDENZA_LOCALITA,
        payload
    };
}
exports.setADVLocalitaResidenzaAction = setADVLocalitaResidenzaAction;
function setADVCAPResidenzaAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_RESIDENZA_CAP,
        payload
    };
}
exports.setADVCAPResidenzaAction = setADVCAPResidenzaAction;
function setADVTipoViaResidenzaAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_RESIDENZA_TIPO_VIA,
        payload
    };
}
exports.setADVTipoViaResidenzaAction = setADVTipoViaResidenzaAction;
function setADVIndirizzoResidenzaAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_RESIDENZA_INDIRIZZO,
        payload
    };
}
exports.setADVIndirizzoResidenzaAction = setADVIndirizzoResidenzaAction;
function setADVNCivicoResidenzaAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_RESIDENZA_NCIVICO,
        payload
    };
}
exports.setADVNCivicoResidenzaAction = setADVNCivicoResidenzaAction;
function setADVProvinciaDomicilioAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOMICILIO_PROVINCIA,
        payload
    };
}
exports.setADVProvinciaDomicilioAction = setADVProvinciaDomicilioAction;
function setADVComuneDomicilioAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOMICILIO_COMUNE,
        payload
    };
}
exports.setADVComuneDomicilioAction = setADVComuneDomicilioAction;
function setADVLocalitaDomicilioAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOMICILIO_LOCALITA,
        payload
    };
}
exports.setADVLocalitaDomicilioAction = setADVLocalitaDomicilioAction;
function setADVCAPDomicilioAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOMICILIO_CAP,
        payload
    };
}
exports.setADVCAPDomicilioAction = setADVCAPDomicilioAction;
function setADVTipoViaDomicilioAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOMICILIO_TIPO_VIA,
        payload
    };
}
exports.setADVTipoViaDomicilioAction = setADVTipoViaDomicilioAction;
function setADVIndirizzoDomicilioAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOMICILIO_INDIRIZZO,
        payload
    };
}
exports.setADVIndirizzoDomicilioAction = setADVIndirizzoDomicilioAction;
function setADVNCivicoDomicilioAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOMICILIO_NCIVICO,
        payload
    };
}
exports.setADVNCivicoDomicilioAction = setADVNCivicoDomicilioAction;
function setADVDocumentoIdentitaTipoDocumentoAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOCUMENTO_IDENTITA_TIPO_DOCUMENTO,
        payload
    };
}
exports.setADVDocumentoIdentitaTipoDocumentoAction = setADVDocumentoIdentitaTipoDocumentoAction;
function setADVDocumentoIdentitaNumeroDocumentoAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOCUMENTO_IDENTITA_NUMERO_DOCUMENTO,
        payload
    };
}
exports.setADVDocumentoIdentitaNumeroDocumentoAction = setADVDocumentoIdentitaNumeroDocumentoAction;
function setADVDocumentoIdentitaLuogoRilascioAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOCUMENTO_IDENTITA_LUOGO_RILASCIO,
        payload
    };
}
exports.setADVDocumentoIdentitaLuogoRilascioAction = setADVDocumentoIdentitaLuogoRilascioAction;
function setADVDocumentoIdentitaDataRilascioAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOCUMENTO_IDENTITA_DATA_RILASCIO,
        payload
    };
}
exports.setADVDocumentoIdentitaDataRilascioAction = setADVDocumentoIdentitaDataRilascioAction;
function setADVDocumentoIdentitaDataScadenzaAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOCUMENTO_IDENTITA_DATA_SCADENZA,
        payload
    };
}
exports.setADVDocumentoIdentitaDataScadenzaAction = setADVDocumentoIdentitaDataScadenzaAction;
function setADVFilesDocumentoIdentitaAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_FILES_DOCUMENTO_IDENTITA,
        payload
    };
}
exports.setADVFilesDocumentoIdentitaAction = setADVFilesDocumentoIdentitaAction;
function setADVFormDocumentoSubmittedAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_FORM_DOCUMENTO_SUBMITTED,
        payload
    };
}
exports.setADVFormDocumentoSubmittedAction = setADVFormDocumentoSubmittedAction;
function setADVDatiResidenzaAction() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_RESIDENZA
    };
}
exports.setADVDatiResidenzaAction = setADVDatiResidenzaAction;
function setADVFormResidenzaSubmittedAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_FORM_RESIDENZA_SUBMITTED,
        payload
    };
}
exports.setADVFormResidenzaSubmittedAction = setADVFormResidenzaSubmittedAction;
function setADVValorizzaRapporti() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_ARRAY_RAPPORTI_SCOPI
    };
}
exports.setADVValorizzaRapporti = setADVValorizzaRapporti;
function setADVScopoRapporto(payload, index) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_SCOPO_RAPPORTO,
        payload,
        index
    };
}
exports.setADVScopoRapporto = setADVScopoRapporto;
function setADVDatiRedditualiProfessione(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_PROFESSIONE,
        payload
    };
}
exports.setADVDatiRedditualiProfessione = setADVDatiRedditualiProfessione;
function setADVDatiRedditualiTAE(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_TAE,
        payload
    };
}
exports.setADVDatiRedditualiTAE = setADVDatiRedditualiTAE;
function setADVDatiRedditualiCAE(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_CAE,
        payload
    };
}
exports.setADVDatiRedditualiCAE = setADVDatiRedditualiCAE;
function setADVDatiRedditualiRedditoAnnuo(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_REDDITO_ANNUO,
        payload
    };
}
exports.setADVDatiRedditualiRedditoAnnuo = setADVDatiRedditualiRedditoAnnuo;
function setADVDatiRedditualiPatrimonioTotaleCliente(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_PATRIMONIO_TOTALE_CLIENTE,
        payload
    };
}
exports.setADVDatiRedditualiPatrimonioTotaleCliente = setADVDatiRedditualiPatrimonioTotaleCliente;
function setADVDatiRedditualiStatoAttivitaEconomicaPrevalente(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_STATO_ATT_EC_PREV,
        payload
    };
}
exports.setADVDatiRedditualiStatoAttivitaEconomicaPrevalente = setADVDatiRedditualiStatoAttivitaEconomicaPrevalente;
function setADVDatiRedditualiProvinciaAttivitaEconomicaPrevalente(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_PROV_ATT_EC_PREV,
        payload
    };
}
exports.setADVDatiRedditualiProvinciaAttivitaEconomicaPrevalente = setADVDatiRedditualiProvinciaAttivitaEconomicaPrevalente;
function setADVDatiRedditualiQualificaLavorativa(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_QUALIFICA_LAVORATIVA,
        payload
    };
}
exports.setADVDatiRedditualiQualificaLavorativa = setADVDatiRedditualiQualificaLavorativa;
function setADVDatiRedditualiNotaTipologia(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_NOTA_TIPOLOGIA,
        payload
    };
}
exports.setADVDatiRedditualiNotaTipologia = setADVDatiRedditualiNotaTipologia;
function setADVDatiRedditualiPrimoPaese(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_PRIMO_PAESE,
        payload
    };
}
exports.setADVDatiRedditualiPrimoPaese = setADVDatiRedditualiPrimoPaese;
function setADVDatiRedditualiSecondoPaese(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_SECONDO_PAESE,
        payload
    };
}
exports.setADVDatiRedditualiSecondoPaese = setADVDatiRedditualiSecondoPaese;
function setADVDatiRedditualiTerzoPaese(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_TERZO_PAESE,
        payload
    };
}
exports.setADVDatiRedditualiTerzoPaese = setADVDatiRedditualiTerzoPaese;
function setADVDatiRedditualiEsercizioDati(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_ESERCIZIO_DATI,
        payload
    };
}
exports.setADVDatiRedditualiEsercizioDati = setADVDatiRedditualiEsercizioDati;
function setADVDatiRedditualiUltimaProfessione(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_ULTIMA_PROFESSIONE,
        payload
    };
}
exports.setADVDatiRedditualiUltimaProfessione = setADVDatiRedditualiUltimaProfessione;
function setADVDatiRedditualiAppaltiPubblici(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_APPALTI_PUBBLICI,
        payload
    };
}
exports.setADVDatiRedditualiAppaltiPubblici = setADVDatiRedditualiAppaltiPubblici;
function setADVDatiRedditualiOrigineReddito(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_ORIGINE_REDDITO,
        payload
    };
}
exports.setADVDatiRedditualiOrigineReddito = setADVDatiRedditualiOrigineReddito;
function setADVDatiRedditualiAOriginePatrimonio(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_ORIGINE_PATRIMONIO,
        payload
    };
}
exports.setADVDatiRedditualiAOriginePatrimonio = setADVDatiRedditualiAOriginePatrimonio;
function setADVFormDatiReddituali() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_FORM_DATI_REDDITUALI
    };
}
exports.setADVFormDatiReddituali = setADVFormDatiReddituali;
function setADVDatiDocumentoIdentita() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DATI_DOCUMENTO_IDENTITA
    };
}
exports.setADVDatiDocumentoIdentita = setADVDatiDocumentoIdentita;
function setADVDisabledFirmaAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DISABLED_FIRMA,
        payload
    };
}
exports.setADVDisabledFirmaAction = setADVDisabledFirmaAction;
function setADVDatiRedSubmitted(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_FORM_DATI_REDDITTUALI_SUBMITTED,
        payload
    };
}
exports.setADVDatiRedSubmitted = setADVDatiRedSubmitted;
function setisUploadLoading(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_IS_UPLOAD_LOADING,
        payload
    };
}
exports.setisUploadLoading = setisUploadLoading;
const modificaQuestionarioADV = () => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(modificaQuestionarioADVStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const request = {
            modificaAdeguataVerificaRequestDto: (0, _1.buildQuestionario)(getState().adeguataVerifica)
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.AdeguataVerificaControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .modificaQuestionarioAdeguataVerifica(request).then((response) => {
                dispatch(modificaQuestionarioADVSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.modificaQuestionarioADV = modificaQuestionarioADV;
function modificaQuestionarioADVStart() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_MODIFICA_QUESTIONARIO_START
    };
}
function modificaQuestionarioADVSuccess(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_MODIFICA_QUESTIONARIO_SUCCESS,
        payload
    };
}
function resetRiepilogoADV() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_RESET_RIEPILOGO
    };
}
exports.resetRiepilogoADV = resetRiepilogoADV;
function resetTotaleADV() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_RESET_TOTALE
    };
}
exports.resetTotaleADV = resetTotaleADV;
const aggiornaDocumentoADV = (file) => async (dispatch, getState, extraArguments) => {
    //dispatch(setLoader(true));
    dispatch(setisUploadLoading(true));
    dispatch(aggiornaDocumentoADVStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        let request = {
            caricaDocumentoIdentitaInDto: {
                filesDocumento: []
            }
        };
        try {
            const files = file;
            request = {
                caricaDocumentoIdentitaInDto: {
                    filesDocumento: files || [{ fileName: 'error', data: [''] }]
                }
            };
        }
        catch (error) {
            console.log(error);
        }
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.DocumentoIdentitaControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .caricaDocumentoIdentita(request).then((response) => {
                dispatch(aggiornaDocumentoADVSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
                dispatch(setisUploadLoading(false));
            }).finally(() => {
                //dispatch(setLoader(false));
                //dispatch(setisUploadLoading(false))
            });
        });
    }
};
exports.aggiornaDocumentoADV = aggiornaDocumentoADV;
function aggiornaDocumentoADVStart() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_AGGIORNA_DOCUMENTO_START
    };
}
function aggiornaDocumentoADVSuccess(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_AGGIORNA_DOCUMENTO_SUCCESS,
        payload
    };
}
function exportPDFADVStart() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_EXPORT_PDF_START
    };
}
function exportPDFADVSuccess(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_EXPORT_PDF_SUCCESS,
        payload
    };
}
const exportADVPDF = (share, title, message) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(exportPDFADVStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.AdeguataVerificaControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, 'application/pdf')).stampaQuestionarioPdf().then((response) => {
                if (extraArguments.platform === 'desktop') {
                    (0, helpers_1.hadlePdfResponse)(response, (url) => dispatch((0, general_actions_1.popUpBlockedPdf)(url)));
                }
                if (extraArguments.platform === 'mobile') {
                    (0, helpers_1.download_sharePDF)(extraArguments, 'questionario.pdf', response, share, title, message);
                }
                dispatch(exportPDFADVSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.exportADVPDF = exportADVPDF;
const getQualificheTaeCaeByProfessione = (key) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getQualificheTaeCaeByProfessioneADVStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const request = {
            codiceProfessione: !!key ? key : getState().adeguataVerifica.formDatiReddituali.professione || ''
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.AdeguataVerificaControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .recuperaDatiProfessioneByCodice(request).then((response) => {
                dispatch(getQualificheTaeCaeByProfessioneADVSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getQualificheTaeCaeByProfessione = getQualificheTaeCaeByProfessione;
function getQualificheTaeCaeByProfessioneADVStart() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_GET_QUALIFICHE_TAE_CAE_BY_PROFESSIONE_START
    };
}
function getQualificheTaeCaeByProfessioneADVSuccess(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_GET_QUALIFICHE_TAE_CAE_BY_PROFESSIONE_SUCCESS,
        payload
    };
}
function setADVModificaDatiDomicilioAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_MODIFICA_DOMICILIO,
        payload
    };
}
exports.setADVModificaDatiDomicilioAction = setADVModificaDatiDomicilioAction;
function setADVModificaDocumentoAction(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_MODIFICA_DOCUMENTO,
        payload
    };
}
exports.setADVModificaDocumentoAction = setADVModificaDocumentoAction;
const salvaDocumentoModificato = () => async (dispatch, getState, extraArguments) => {
    var _a, _b;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(salvaDocumentoModificatoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const state = getState().adeguataVerifica;
        const request = {
            apriPraticaInDto: {
                tokenIdentifier: state.esitoCaricamentoDocumento.tokenIdentifier,
                datiDocumento: {
                    numero: state.formDocumentoIdentita.numDocumento,
                    luogoRilascio: state.formDocumentoIdentita.luogoRilascio,
                    dataEmissione: (_a = state.formDocumentoIdentita) === null || _a === void 0 ? void 0 : _a.dataRilascio,
                    dataScadenza: (_b = state.formDocumentoIdentita) === null || _b === void 0 ? void 0 : _b.dataScadenza
                }
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.DocumentoIdentitaControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .apriPratica(request).then((response) => {
                dispatch(salvaDocumentoModificatoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.salvaDocumentoModificato = salvaDocumentoModificato;
function salvaDocumentoModificatoStart() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SALVA_DOCUMENTO_MODIFICATO_START
    };
}
function salvaDocumentoModificatoSuccess(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SALVA_DOCUMENTO_MODIFICATO_SUCCESS,
        payload
    };
}
function resetFormDocumentoIdentita() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_RESET_FORM_DOCUMENTI_ACTION
    };
}
exports.resetFormDocumentoIdentita = resetFormDocumentoIdentita;
function resetTotaleDocumento() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_RESET_TOTALE_DOCUMENTO
    };
}
exports.resetTotaleDocumento = resetTotaleDocumento;
function setDocumentoModificato(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_DOCUMENTO_MODIFICATO,
        payload
    };
}
exports.setDocumentoModificato = setDocumentoModificato;
const verificaCaricamentoDocumentoADV = () => async (dispatch, getState, extraArguments) => {
    dispatch(verificaCaricamentoDocumentoADVStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        let request = {
            tokenIdentifier: getState().adeguataVerifica.esitoCaricamentoDocumento.tokenIdentifier || ''
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.DocumentoIdentitaControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .daticaricamentoDocumentoIdentita(request).then((response) => {
                dispatch(verificaCaricamentoDocumentoADVSuccess(response));
                if (response.stato == api_rest_1.DatiCaricamentoDocumentoIdentitaOutDtoStatoEnum.OK) {
                    dispatch(setisUploadLoading(false));
                }
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
                dispatch(setisUploadLoading(false));
            });
        });
    }
};
exports.verificaCaricamentoDocumentoADV = verificaCaricamentoDocumentoADV;
function verificaCaricamentoDocumentoADVStart() {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_VERIFICA_CARICAMENTO_DOCUMENTO_START
    };
}
function verificaCaricamentoDocumentoADVSuccess(payload) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_VERIFICA_CARICAMENTO_DOCUMENTO_SUCCESS,
        payload
    };
}
function setOrigineDestinazioneFondi(payload, index) {
    return {
        type: adeguataVerifica_types_1.EReduxAdeguataVerificaActionTypes.ADV_SET_ORIGINE_DESTINAZIONE_FONDI,
        payload,
        index
    };
}
exports.setOrigineDestinazioneFondi = setOrigineDestinazioneFondi;
